/**
 * Recaptcha helper.
 *
 */
class RecaptchaClass {
    /**
     * Class constructor
     * Defines the default executed flag
     */
    constructor() {
        this.value = null;
        this.once = false;
        this.executed = false;
    }

    /**
     *
     * @param $el
     */
    setInputElement($el) {
        this.inputElement = $el;
    }

    /**
     * Call execute to start up recaptcha, call the script if necessary and run
     * whatever code you provide.
     *
     * @param done Success callback
     * @param fail Failure callback
     * @returns {RecaptchaClass}
     */
    execute(done, fail) {
        // No recaptcha defined
        if (typeof this.inputElement === 'undefined') {
            fail();
            console.log('no input defined');
            return this;
        }


        if (typeof window.grecaptcha === 'undefined') {
            this.executed = false;
            // Async recaptcha loading callback
            window.onRecaptchaLoadCallback = () => {
                this.execute(done, fail);
            };

            this.getScript('https://www.google.com/recaptcha/api.js?hl=fr&onload=onRecaptchaLoadCallback', () => {
            });

            this.once = true;
            return this;
        }

        // Callback for success as defined in RecaptchaAwareTrait
        window.submitRecaptchaForm = () => {
            this.executed = true;
            this.value = grecaptcha.getResponse();
            if (this.inputElement) {
                this.inputElement.val(this.value);
            }
            done();
        };

        // Callback for failure as defined in RecaptchaAwareTrait
        window.failedRecaptchaForm = () => {
            this.executed = false;
            fail();
        };

        // sitekey: 6LfAMJwUAAAAAKEKDIwzxF_5oGq8qpbUZSHVc8Cy
        if (!this.executed) {
            this.captcha = window.grecaptcha.render(this.inputElement.get(0));
        }

        if (this.executed) {
            window.grecaptcha.reset();
        }

        window.grecaptcha.execute(this.captcha);
        return this;
    }

    /**
     * Vanilla getScript function
     *
     * @param src
     * @param cb
     */
    getScript (src, cb) {
        let script = document.createElement('script');
        let prior = document.getElementsByTagName('script')[0];
        // script.async = 1;

        script.onload = script.onreadystatechange = function( _, isAbort ) {
            if(isAbort || !script.readyState || /loaded|complete/.test(script.readyState) ) {
                script.onload = script.onreadystatechange = null;
                script = undefined;
                if(!isAbort && cb) setTimeout(cb, 0);
            }
        };

        script.src = src;
        prior.parentNode.insertBefore(script, prior);
    }
}

let RecaptchaInstance = new RecaptchaClass();

export { RecaptchaInstance as Recaptcha };
